import { EmailDesign } from "@/stores/emailBuilderStore";

export const DefaultUpdatedRecurringScheduleEmail = (design: EmailDesign) => {
    return {
        page: {
            body: {
                container: {
                    style: {
                        "background-color": "#FFFFFF",
                    },
                },
                content: {
                    computedStyle: {
                        align: "center",
                        linkColor: "#0015ADE8",
                        messageBackgroundColor: "transparent",
                        messageWidth: "600px",
                    },
                    style: {
                        color: "#000000",
                        "font-family":
                            "'Helvetica Neue', Helvetica, Arial, sans-serif",
                    },
                },
                webFonts: [],
            },
            description: "",
            rows: [
                {
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-repeat": "no-repeat",
                            "background-position": "top left",
                        },
                    },
                    content: {
                        style: {
                            "background-color": "transparent",
                            color: "#000000",
                            width: "500px",
                            "background-image": "none",
                            "background-repeat": "no-repeat",
                            "background-position": "top left",
                            "border-top": "0px solid transparent",
                            "border-right": "0px solid transparent",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "0px",
                        },
                        computedStyle: {
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                            hideContentOnMobile: false,
                            hideContentOnDesktop: false,
                        },
                    },
                    columns: [
                        {
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "35px",
                            },
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnAmp: false,
                                            hideContentOnDesktop: false,
                                            hideContentOnHtml: false,
                                            hideContentOnMobile: false,
                                        },
                                        html: {
                                            html: `<img src="${design.logoUrl}" alt="Organization Logo" style="width:25%;" />`,
                                        },
                                        style: {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-html",
                                    uuid: "bbd1b052-a255-4b89-800a-316190928c37",
                                },
                            ],
                            "grid-columns": 12,
                            uuid: "60dbeaeb-b391-47b6-9b74-32df80787ebb",
                        },
                    ],
                    type: "one-column-empty",
                    uuid: "c9b01b65-02aa-4e6b-98bc-64b2ad8acc59",
                },
                {
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-repeat": "no-repeat",
                            "background-position": "top left",
                        },
                    },
                    content: {
                        style: {
                            "background-color": "transparent",
                            color: "#000000",
                            width: "500px",
                            "background-image": "none",
                            "background-repeat": "no-repeat",
                            "background-position": "top left",
                            "border-top": "0px solid transparent",
                            "border-right": "0px solid transparent",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "0px",
                        },
                        computedStyle: {
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                            hideContentOnMobile: false,
                            hideContentOnDesktop: false,
                        },
                    },
                    columns: [
                        {
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "20px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "10px",
                            },
                            modules: [
                                {
                                    type: "mailup-bee-newsletter-modules-text",
                                    descriptor: {
                                        text: {
                                            html: '<div class="txtTinyMce-wrapper" style="font-size: 14px; line-height: 16px;" data-mce-style="font-size: 14px; line-height: 16px;"><p style="font-size: 14px; line-height: 16px; word-break: break-word;" data-mce-style="font-size: 14px; line-height: 16px;"><span style="font-size: 26px; line-height: 31px;" data-mce-style="font-size: 26px; line-height: 31px;">Your recurring gift has been updated</span></p></div>',
                                            style: {
                                                color: "#333333",
                                                "line-height": "120%",
                                                "font-family": "inherit",
                                            },
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                        },
                                        style: {
                                            "padding-top": "25px",
                                            "padding-right": "30px",
                                            "padding-bottom": "0px",
                                            "padding-left": "30px",
                                        },
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        mobileStyle: {},
                                    },
                                    uuid: "aa44a579-baa2-4e5c-b9b1-b541bb3257a8",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            align: "center",
                                            hideContentOnMobile: false,
                                        },
                                        divider: {
                                            style: {
                                                "border-top":
                                                    "1px solid #DADADA",
                                                width: "100%",
                                            },
                                        },
                                        style: {
                                            "padding-bottom": "25px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "40px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-divider",
                                    uuid: "a0fb29ab-1460-49eb-bef5-8826bd31c045",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size: 14px; line-height: 21px; font-family: inherit;" data-mce-style="font-size: 14px; line-height: 21px; font-family: inherit;"><p style="line-height: 18px; word-break: break-word; text-align: left;" data-renderer-start-pos="8929" data-mce-style="line-height: 18px; word-break: break-word; text-align: left;"><span style="font-size: 16px; line-height: 24px;" data-mce-style="font-size: 16px; line-height: 24px;">Please verify the details of your updated recurring schedule. If everything looks correct, then no action is needed. If you did not request these changes to be made, please contact us or make further updates in the Donor Portal.</span></p></div>',
                                            style: {
                                                color: "#555555",
                                                "font-family": "inherit",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "7d2a217c-2a00-436b-96fa-fa799beef3ce",
                                },
                            ],
                            "grid-columns": 12,
                            uuid: "8baba2f7-1d79-482b-8d13-7dc3b58a1429",
                        },
                    ],
                    type: "one-column-empty",
                    uuid: "090acb05-cf31-461a-bb85-c7062ddf4dbc",
                },
                {
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-repeat": "no-repeat",
                            "background-position": "top left",
                        },
                    },
                    content: {
                        style: {
                            "background-color": "#fafafa",
                            color: "#000000",
                            width: "500px",
                            "background-image": "none",
                            "background-repeat": "no-repeat",
                            "background-position": "top left",
                            "border-top": "0px solid transparent",
                            "border-right": "0px solid transparent",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-radius": "20px",
                        },
                        computedStyle: {
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                            hideContentOnMobile: false,
                            hideContentOnDesktop: false,
                        },
                    },
                    columns: [
                        {
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "30px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "25px",
                            },
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size: 14px; line-height: 16px; font-family: inherit;" data-mce-style="font-size: 14px; line-height: 16px; font-family: inherit;"><p style="font-size: 15px; line-height: 18px; word-break: break-word; text-align: center;" data-mce-style="font-size: 15px; line-height: 18px; word-break: break-word; text-align: center;"><span style="font-size: 15px; line-height: 18px;" data-mce-style="font-size: 15px; line-height: 18px;"><strong>Organization Name</strong></span><br><span style="font-size: 15px; line-height: 18px;" data-mce-style="font-size: 15px; line-height: 18px;">{{OrganizationName}}</span></p><p style="font-size: 15px; line-height: 18px; word-break: break-word; text-align: center;" data-mce-style="font-size: 15px; line-height: 18px; word-break: break-word; text-align: center;">&nbsp;</p><p style="line-height: 18px; word-break: break-word; font-size: 15px; text-align: center;" data-renderer-start-pos="11876" data-mce-style="line-height: 18px; word-break: break-word; font-size: 15px; text-align: center;"><span style="font-size: 15px; line-height: 18px;" data-mce-style="font-size: 15px; line-height: 18px;"><strong data-renderer-mark="true">Recurring Gift Status</strong></span></p><p style="line-height: 18px; word-break: break-word; font-size: 15px; text-align: center;" data-renderer-start-pos="11899" data-mce-style="line-height: 18px; word-break: break-word; font-size: 15px; text-align: center;"><span style="font-size: 15px; line-height: 18px;" data-mce-style="font-size: 15px; line-height: 18px;">{{RecurringGiftStatus}}</span></p><p style="font-size: 15px; line-height: 18px; word-break: break-word; text-align: center;" data-mce-style="font-size: 15px; line-height: 18px; word-break: break-word; text-align: center;"><br><span style="font-size: 15px; line-height: 18px;" data-mce-style="font-size: 15px; line-height: 18px;"><strong>Gift Amount</strong></span><br><span style="font-size: 15px; line-height: 18px;" data-mce-style="font-size: 15px; line-height: 18px;">{{RecurringGiftAmount}}</span><br><br><span style="font-size: 15px; line-height: 18px;" data-mce-style="font-size: 15px; line-height: 18px;"><strong>Payment Method</strong></span><br><span style="font-size: 15px; line-height: 18px;" data-mce-style="font-size: 15px; line-height: 18px;">{{RecurringGiftPaymentLast4}}</span></p><p style="font-size: 15px; line-height: 18px; word-break: break-word; text-align: center;" data-mce-style="font-size: 15px; line-height: 18px; word-break: break-word; text-align: center;">&nbsp;</p><p style="font-size: 15px; line-height: 18px; word-break: break-word; text-align: center;" data-mce-style="font-size: 15px; line-height: 18px; word-break: break-word; text-align: center;"><span style="font-size: 15px; line-height: 18px;" data-mce-style="font-size: 15px; line-height: 18px;"><strong>Frequency</strong></span><br><span style="font-size: 15px; line-height: 18px;" data-mce-style="font-size: 15px; line-height: 18px;">{{RecurringFrequency}}</span><br><br><span style="font-size: 15px; line-height: 18px;" data-mce-style="font-size: 15px; line-height: 18px;"><strong>Next Charge Date</strong></span><br><span style="font-size: 15px; line-height: 18px;" data-mce-style="font-size: 15px; line-height: 18px;">{{NextChargeDate}}</span><br><br><span style="font-size: 15px; line-height: 18px;" data-mce-style="font-size: 15px; line-height: 18px;"><strong>Project Allocation(s)</strong></span><br><span style="font-size: 15px; line-height: 18px;" data-mce-style="font-size: 15px; line-height: 18px;">{{RecurringGiftProjects}}</span></p></div>',
                                            style: {
                                                color: "#6f6f6f",
                                                "font-family": "inherit",
                                                "line-height": "120%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "b480ec45-6193-4378-811b-9370e69705aa",
                                },
                            ],
                            "grid-columns": 12,
                            uuid: "1b627b8f-66f0-4e31-9657-623a6510745b",
                        },
                    ],
                    type: "one-column-empty",
                    uuid: "08025e0d-8a6e-46ff-b256-e4b379db5073",
                },
                {
                    columns: [
                        {
                            "grid-columns": 12,
                            modules: [
                                {
                                    descriptor: {
                                        computedStyle: {
                                            align: "center",
                                            hideContentOnMobile: false,
                                        },
                                        divider: {
                                            style: {
                                                "border-top":
                                                    "1px solid #DADADA",
                                                width: "100%",
                                            },
                                        },
                                        style: {
                                            "padding-bottom": "35px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "45px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-divider",
                                    uuid: "eb0a1179-8071-40b3-90bd-3c9da4313a47",
                                },
                                {
                                    type: "mailup-bee-newsletter-modules-text",
                                    descriptor: {
                                        text: {
                                            html: '<div class="txtTinyMce-wrapper" style="font-size: 14px; line-height: 16px;" data-mce-style="font-size: 14px; line-height: 16px;"><p style="font-size: 14px; line-height: 16px; word-break: break-word;" data-mce-style="font-size: 14px; line-height: 16px;"><span style="font-size: 18px; line-height: 21px;" data-mce-style="font-size: 18px; line-height: 21px;">Manage Your Donation</span></p></div>',
                                            style: {
                                                color: "#333333",
                                                "line-height": "120%",
                                                "font-family": "inherit",
                                            },
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                        },
                                        style: {
                                            "padding-top": "0px",
                                            "padding-right": "30px",
                                            "padding-bottom": "7px",
                                            "padding-left": "30px",
                                        },
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        mobileStyle: {},
                                    },
                                    uuid: "b15fd38f-82d3-4b85-bbe7-a876086549df",
                                    locked: false,
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            hideContentOnMobile: false,
                                        },
                                        style: {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px",
                                        },
                                        text: {
                                            computedStyle: {
                                                linkColor: "#0015ADE8",
                                            },
                                            html: '<div class="txtTinyMce-wrapper" style="font-size: 14px; line-height: 16px; font-family: inherit;" data-mce-style="font-size: 14px; line-height: 16px; font-family: inherit;"><p style="line-height: 14px; word-break: break-word; text-align: left;" data-renderer-start-pos="9306" data-mce-style="line-height: 14px; word-break: break-word; text-align: left;"><span style="font-size: 15px; line-height: 18px;" data-mce-style="font-size: 15px; line-height: 18px;">Easily update your contact information, make changes to your recurring gift, and have receipts resent to you by email.</span></p></div>',
                                            style: {
                                                color: "#555555",
                                                "font-family": "inherit",
                                                "line-height": "150%",
                                            },
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-text",
                                    uuid: "265055a4-7b29-4164-870a-1d065bebc172",
                                },
                                {
                                    descriptor: {
                                        button: {
                                            href: "{{DonorPortalLogin}}",
                                            label: '<div class="txtTinyMce-wrapper" style="" data-mce-style=""><p dir="ltr" style="word-break: break-word;" data-mce-style="word-break: break-word;">Donor Portal Login</p></div>',
                                            style: {
                                                "background-color": "#333333",
                                                "border-bottom":
                                                    "0px solid transparent",
                                                "border-left":
                                                    "0px solid transparent",
                                                "border-radius": "30px",
                                                "border-right":
                                                    "0px solid transparent",
                                                "border-top":
                                                    "0px solid transparent",
                                                color: "#FFFFFF",
                                                direction: "ltr",
                                                "font-family": "inherit",
                                                "font-size": "15px",
                                                "font-weight": "400",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "35px",
                                                "padding-right": "35px",
                                                "padding-top": "5px",
                                                width: "auto",
                                            },
                                            target: "_blank",
                                        },
                                        computedStyle: {
                                            height: 40,
                                            hideContentOnMobile: false,
                                            width: 196,
                                        },
                                        style: {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px",
                                            "text-align": "left",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-button",
                                    uuid: "e0160e25-3dcf-4675-bd30-37aad81a3688",
                                },
                                {
                                    descriptor: {
                                        computedStyle: {
                                            align: "center",
                                            hideContentOnMobile: false,
                                        },
                                        divider: {
                                            style: {
                                                "border-top":
                                                    "1px solid #DADADA",
                                                width: "100%",
                                            },
                                        },
                                        style: {
                                            "padding-bottom": "25px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "35px",
                                        },
                                    },
                                    locked: false,
                                    type: "mailup-bee-newsletter-modules-divider",
                                    uuid: "ce7fee19-f82c-4b6b-813d-f77d699a093f",
                                },
                            ],
                            style: {
                                "background-color": "transparent",
                                "border-bottom": "0 solid transparent",
                                "border-left": "0 solid transparent",
                                "border-right": "0 solid transparent",
                                "border-top": "0 solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px",
                            },
                            uuid: "de6e5770-f804-49e1-b9ef-bea405585617",
                        },
                    ],
                    container: {
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                        },
                    },
                    content: {
                        computedStyle: {
                            hideContentOnDesktop: false,
                            hideContentOnMobile: false,
                            rowColStackOnMobile: true,
                            rowReverseColStackOnMobile: false,
                            verticalAlign: "top",
                        },
                        style: {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            color: "#000000",
                            width: "600px",
                        },
                    },
                    empty: false,
                    locked: false,
                    synced: false,
                    type: "one-column-empty",
                    uuid: "eddcce8f-b612-4771-8f62-e2929593f00d",
                },
            ],
            template: {
                version: "2.0.0",
            },
            title: "",
        },
        comments: {},
    };
};
